import { isTempId } from "./outbox";

export const SEEN_ENTRIES_KEY = "split-it:seen-entries";

const serverIds = (expenses = []) =>
  expenses.map((e) => `${e.id}`).filter((id) => !isTempId(id));

export const countUnseen = (seen, group) => {
  const seenIds = seen?.[group?.id];
  if (!seenIds) return 0;
  const known = new Set(seenIds);
  return serverIds(group.expenses).filter((id) => !known.has(id)).length;
};

export const markSeen = (seen, group) => ({
  ...seen,
  [group.id]: serverIds(group.expenses),
});

export const readSeen = (storage) => {
  try {
    const value = JSON.parse(storage.getItem(SEEN_ENTRIES_KEY));
    return value && typeof value === "object" ? value : {};
  } catch (error) {
    return {};
  }
};

export const writeSeen = (storage, seen) => {
  try {
    storage.setItem(SEEN_ENTRIES_KEY, JSON.stringify(seen));
  } catch (error) {}
};
